import { IRole } from "../models";
import { IRolesStoreState } from "./models";

export function filterOutTeamRoles(state: IRolesStoreState): IRole[] {
  return state.roles.items.filter((role) => !role.teamId);
}
